import { memo } from 'react'
import cn from 'classnames'

import { Avatar } from '@shared'

import styles from './SquadListItemRanking.module.scss'

interface SquadListItemRankingProps {
  rank: number
  name: string
  score: number
  avatarUrl: string
  effectUrl?: string | null
  groupColorIndex?: number | null
  isFirstInGroup?: boolean
  isLastInGroup?: boolean
}

const formatScore = (score: number): string => {
  return new Intl.NumberFormat('en-US').format(score)
}

export const SquadListItemRanking = memo(function SquadListItemRanking({
  rank,
  name,
  score,
  avatarUrl,
  effectUrl,
  groupColorIndex,
  isFirstInGroup,
  isLastInGroup,
}: SquadListItemRankingProps) {
  return (
    <div
      className={cn(styles.item, {
        [styles[`groupColor${groupColorIndex}`]]:
          groupColorIndex !== null && groupColorIndex !== undefined,
        [styles.firstInGroup]: isFirstInGroup,
        [styles.lastInGroup]: isLastInGroup,
      })}
    >
      <div className={styles.itemContent}>
        <div className={styles.rankSection}>
          <div className={styles.rank}>{rank}</div>

          <Avatar
            srcAvatar={avatarUrl}
            srcEffect={effectUrl || ''}
            className={styles.avatarContainer}
            eager={false}
          />

          <div className={styles.name}>{name}</div>
        </div>
        <div className={styles.scoreSection}>
          <span className={styles.score}>{formatScore(score)} $NOT</span>
        </div>
      </div>
      <div className={styles.youIndicator}>
        <span className={styles.youText}>you</span>
      </div>
      <div className={styles.rankingGlow} />
    </div>
  )
})
